import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";
export function getJournalTransactionDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getJournalDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionRelationshipcontact(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/relationshipcontact${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCustomAutoInvoiceRequest(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/autoInvoiceRequest${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getJournalTransactionLineItems(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/journalItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionRelatedRecordsPayments(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/payment${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionAutoShipNoticeRequest(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/autoShipNoticeRequest${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionSalesOrderHoldHistory(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/salesOrderholdhistory${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCostData(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCostdata${q}`, {
    headers: {
      authorization: token,
    },
  });
}
